import Repository from "@/repositories/RepositoryFactory";
import APISTATE from "../../enums/APISTATE";

let openResolve, openReject;

const reports = Repository.get("reports");


export default {
    namespaced: true,
    state: {
        salaryTypeGroup: [],
        availableSalaryTypes: [],
        isOpenSalary: false,
        filterSalary: {}
    },
    mutations: {
        setChosenSalaryType(state, salaryTypeId) {
            const index = state.salaryTypeGroup.findIndex(
                (gm) => gm.salaryTypeId == salaryTypeId
            );
            if (index !== -1) {
                state.salaryTypes[index].isSelected = true;
            }

            state.availableSalaryTypes[
                state.availableSalaryTypes.findIndex(
                    (gm) => gm.salaryTypeId == salaryTypeId
                )
            ].isSelected = true;
        },

        setRejectedSalaryType(state, salaryTypeId) {
            const index = state.salaryTypeGroup.findIndex(
                (gm) => gm.salaryTypeId == salaryTypeId
            );
            if (index !== -1) {
                state.salaryTypes[index].isSelected = false;
            }

            state.availableSalaryTypes[
                state.availableSalaryTypes.findIndex(
                    (gm) => gm.salaryTypeId == salaryTypeId
                )
            ].isSelected = false;
        },

        setSalaryIsOpen(state, isOpenSalary) {
            state.isOpenSalary = isOpenSalary;
        },

        setSalaryTypes(state, response) {
            state.salaryTypeGroup = response;
            state.apiState = APISTATE.LOADED;
        },

        setAvailableSalaryTypes(state, response) {
            state.availableSalaryTypes = response;
        },


        setSalaryFilter(state, filterSalary) {
            state.filterSalary = filterSalary
        }
    },
    actions: {
        async salarySidebarOpenAsync({ commit }) {
            commit("setSalaryIsOpen", true);
            return new Promise((resolve, reject) => {
                openResolve = resolve;
                openReject = reject;
            });
        },
        markSalaryTypeId({ commit, state }, salaryTypeId) {
            const specificSalaryType = state.salaryTypeGroup.find(
                (gm) => gm.salaryTypeId === salaryTypeId
            );
            specificSalaryType.isSelected
                ? commit("setRejectedSalaryType", salaryTypeId)
                : commit("setChosenSalaryType", salaryTypeId);
        },
        deSelectAll({ commit, state }) {
					state.salaryTypeGroup.forEach((agm) => {
						if (agm.isSelected) {
							console.log(agm)
							agm.isSelected = false;
						}						
					});
        },
        selectAll({ commit, state }) {
					state.salaryTypeGroup.forEach((agm) => {
						agm.isSelected = true;
					});
        },
        sidebarCancel: ({ commit, state }) => {
            if (openResolve instanceof Function) {
                openResolve({
                    action: "cancel",
                    markedSalaryTypes: [],
                });
            }
            commit("setSalaryIsOpen", false);
        },
        setSalaryIsOpen: ({ commit }) => {
            commit("setSalaryIsOpen", true);
        },
        updateParentView: ({ commit, state }) => {
            if (openResolve instanceof Function) {
                openResolve({
                    action: "update",
                    markedSalaryTypes: state.salaryTypeGroup.filter(
                        (gm) => gm.isSelected
                    ),
                });
            }
            commit("setSalaryIsOpen", false);
        },
        searchForSalaryType: ({ commit, state }, searchTerm) => {
            let salaryTypes;
            if (searchTerm === "") {
                salaryTypes = state.availableSalaryTypes;
            } else {
                salaryTypes = state.availableSalaryTypes.filter(
                    (gm) =>
                        gm.salaryTypeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        gm.salaryTypeId
                            .toString()
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase())
                );
            }

            if (salaryTypes === undefined) {
                commit("setsalaryTypes", []);
            } else {
                commit("setsalaryTypes", salaryTypes);
            }
        },
        setSalaryTypes({ commit, state }, salaryTypes) {
            commit("setSalaryTypes", salaryTypes);
            commit("setAvailableSalaryTypes", salaryTypes);
        },
        setFilter({ commit }, filterSalary) {
            commit("setSalaryFilter", filterSalary);
        }
    },
    getters: {
        salaryTypes: (state) => state.salaryTypes,
        isOpenSalary: (state) => state.isOpenSalary,
        filterSalary: (state) => state.filterSalary,
        availableSalaryTypes: (state) => state.availableSalaryTypes,
        salaryTypeGroup: (state) => state.salaryTypeGroup
    },
}